import { useState, useEffect } from "react";
import dayjs from 'dayjs';

import { Form, Spin, Card, Tabs, Row, Col, Input, Button } from "antd";
import { PageHeader } from '@ant-design/pro-components';
import { UserOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";

import { apiCand } from "../../../../services/apiCand";
import { apiAuxiliar, obterCaracteristicasConselheiro } from "../../../../services/apiAuxiliar";
import { getEntidadesLiberadasS3 } from "../../../../auth/entidadeUsuario";
import { maskCpf } from "../../../../utils/maskFunctions";
import "../style.css";

import { ICaracteristicasMandato, IMandatoDirigente } from "../../Componentes/InterfaceMandato";
import { ICtrlDoc } from "../../../../Interfaces/DadosPrevicInterfaces";

import CadInfoBotoes from "../../Componentes/CadInfoBotoes";
import ConselheiroPerfil from "../Componentes/ConselheiroPerfil"
import DirigenteCaracteristica from "../../Componentes/DirigenteCaracteristica";
import DirigenteHabilitacao from "../../Componentes/DirigenteHabilitacao";
import DirigenteDocumento from "../../Componentes/DirigenteDocumento";

import { resetColor } from "../../../../styles/cnpjColor";
import { errorMessage, mostrarInfo, mostrarInfoDetail, successMessage } from "../../../../utils/messages";
import { IMandatoCaracteristica, IMandatoHabilitacao, IDocumentoMandato } from "../../Componentes/InterfaceMandato";
import { IErroApi } from "../../../../Interfaces/Interfaces";

import { isStateWithoutDataValid, onlyNumbers } from "../../../../utils/utilsFunctions";
import PessoaFisicaDadosPessoaisComplementares from "../../../PessoaFisica/Componentes/PessoaFisicaDadosPessoaisComplementares";
import { useLocation } from "react-router";
import { IEntidade } from "../../../../Interfaces/DadosPrevicInterfaces";
import { modalApi } from "../../../../config/AntdGlobalProvider";


const Cadastrar = (props: any) => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [form] = Form.useForm();
  const [conselheiroRetPosCadastro, setConselheiroRetPosCadastro] = useState<IMandatoDirigente>();

  const [mandatoCaracteristica, setMandatoCaracteristicas] = useState<IMandatoCaracteristica[]>([]);

  const [habilitacoes, setHabilitacoes] = useState<IMandatoHabilitacao[]>([]);

  const [mandatoDocumentos, setMandatoDocumentos] = useState<IDocumentoMandato[]>([]);

  const [manter, setManter] = useState(1); // 1 : Inserir / 2 : Consultar / 3 : Editar;
  const [erroApi, setErroApi] = useState<IErroApi>()

  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")
  const [confirmaTrocaDirigenteMaximo, setConfirmaTrocaDirigenteMaximo] = useState(false)

  const [mostrarDetalhesPessoaFisica, setMostrarDetalhesPessoaFisica] = useState(false)

  const [valueCategoria, setValueCategoria] = useState(2);
  const [valueCondicao, setValueCondicao] = useState(1);
  const [valueRepresentacao, setValueRepresentacao] = useState(1);

  const [entidades, setEntidades] = useState<IEntidade[]>([]);


  useEffect(() => {
    if (isStateWithoutDataValid(state)) {
      form.setFieldsValue({
        "nuCpf": maskCpf(state.nuCpf),
        "nmPessoaFisica": state.nmPessoaFisica,
      });
    }

    const entidadeUsuario = getEntidadesLiberadasS3();
    setEntidades(entidadeUsuario);
    if (entidadeUsuario.length === 1){
      form.setFieldsValue({
        "matriculaEfpc": entidadeUsuario[0].matricula,
        "sigla": entidadeUsuario[0].sigla,
      });
    }

    if (ctrlDocCons.length === 0) getCtrlDocCons();

    if (caracteristicasMandato.length === 0) getCaracteristicasMandato();

  }, []);


  useEffect(() => {
    if (conselheiroRetPosCadastro) pushToManter(conselheiroRetPosCadastro);
  }, [conselheiroRetPosCadastro]);


  useEffect(() => {
    if (confirmaTrocaDirigenteMaximo) validarConselheiro();
  }, [confirmaTrocaDirigenteMaximo]);


  function pushToManter(conselheiro: any) {  // ABRE A TELA DE DETALHES DO DIRETOR

    let tpSelecao = {
      nuCpf: onlyNumbers(form?.getFieldValue("nuCpf")),
      nmPessoaFisica: form?.getFieldValue("nmPessoaFisica").toUpperCase(),
      matriculaEfpc: conselheiro.matriculaEfpc,
      sigla: form?.getFieldValue("sigla").toUpperCase(),
      manter: 2,
      data: conselheiro
    }
    navigate("/dirigente/conselheiro/manter", { state: tpSelecao });
  }


  useEffect(() => {
    if (erroApi) {
      if (estadoErroApi === 206) {
        modalApi.confirm({
          title: props.manter === 1 ? "Deseja confirmar o cadastro?" : "Deseja confirmar as alterações?",
          width: "700px",
          icon: <ExclamationCircleOutlined />,
          content: msgErroApi,
          okButtonProps: { id: 'ok' },
          onOk() {
            setConfirmaTrocaDirigenteMaximo(true);
          },
          onCancel() { },
        });

      } else if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi);
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setConfirmaTrocaDirigenteMaximo(false);
      setEstadoErroApi(0);
      setMsgErroApi("");

    }
  }, [erroApi])

  // Flag para disparar o Carregamento da Pagina
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const [touched, setTouched] = useState(true);

  const validarConselheiro = () => {
    form
      .validateFields([
        "matriculaEfpc",
        "dtInicioMandato",
        "dtFimMandato",
        "dtInicioExercicio",
        "dtFimExercicio",
      ])
      .then(() => {
        sendForm();
      })
      .catch((error) => {
        errorMessage("Campo obrigatório não preechido");
      });
    //  }
  };

  const sendForm = async () => {
    setTipLoading("Salvando dados ...");
    setLoading(true);
    const json: IMandatoDirigente = {
      idMandato: -1,
      idPessoaFisica: state.idPessoaFisica,
      matriculaEfpc: form?.getFieldValue("matriculaEfpc"),
      csCategoria: valueCategoria,
      dtInicioMandato: form?.getFieldValue("dtInicioMandato") ? dayjs(form?.getFieldValue("dtInicioMandato")).format("YYYY-MM-DD") : "",
      dtFimMandato: form?.getFieldValue("dtFimMandato") ? dayjs(form?.getFieldValue("dtFimMandato")).format("YYYY-MM-DD") : "",
      dtInicioExercicio: form?.getFieldValue("dtInicioExercicio") ? dayjs(form?.getFieldValue("dtInicioExercicio")).format("YYYY-MM-DD") : "",
      dtFimExercicio: form?.getFieldValue("dtFimExercicio") ? dayjs(form?.getFieldValue("dtFimExercicio")).format("YYYY-MM-DD") : "",
      csCondicaoMandato: valueCondicao,
      csRepresentacao: valueRepresentacao,
      prorrogacao: false,
      reconducao: false,
      statusReg: 1,
      confirmaTrocaDirigenteMaximo: confirmaTrocaDirigenteMaximo,
      mandatoCaracteristicas: mandatoCaracteristica.map((e: IMandatoCaracteristica) => {
        return {
          ...e
        };
      }),
      habilitacoes: habilitacoes.map((e: IMandatoHabilitacao) => {
        return {
          ...e
        };
      }),
      mandatoDocumentos: mandatoDocumentos.map((e: IDocumentoMandato) => {
        return {
          ...e
        };
      }),

    };
    // console.log("Subindo json");
    // console.log(json);

    await apiCand.post(`/mandatoconselheiro`, json).then((response) => {
      setLoading(false);

      if (response.data.status === 206) {
        setEstadoErroApi(response.data.status);
        setMsgErroApi(response.data.message);
        setErroApi(response.data);
      } else {
        resetForm();
        successMessage(
          `Conselheiro ${form?.getFieldValue("nmPessoaFisica")} (${maskCpf(form.getFieldValue("nuCpf"))}) cadastrado com Sucesso`
        );
        setConselheiroRetPosCadastro(response.data);
      }
    })
      .catch(err => {
        let data: IErroApi = err.response.data;
        let msgErro = data.mensagem ? data.mensagem : err.response.data.message;
        let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
        setEstadoErroApi(err.response.status);
        setMsgErroApi(msgErro + msgDetalheErro);
        if (err.response.status < 500) {
          setErroApi(data);
        } else {
          errorMessage(msgErro);
        }
        setLoading(false);
      });


  };

  const resetForm = () => {
    setLoading(true);
    form.getFieldsValue();
    setConselheiroRetPosCadastro(undefined);
    setMandatoCaracteristicas([]);
    setHabilitacoes([]);
    form.setFieldsValue({
      matriculaEfpc: undefined,
      dtInicioMandato: undefined,
    });
    setLoading(false);
    window.scrollTo(0, 0)
  };

  const [ctrlDocCons, setCtrlDocCons] = useState<ICtrlDoc[]>([]);
  const getCtrlDocCons = async () => {
    let lQuery = `/auxiliar/tabelas/ctrldoc-tipo-doc/propriedades?propriedades=previc,entidade,cadastrar,conselheiro-deliberativo,conselheiro-fiscal,contexto,transacao`;
    const { data } = await apiAuxiliar.get(lQuery);
    setCtrlDocCons(data.content);
  };

  const [caracteristicasMandato, setCaracteristicasMandato] = useState<ICaracteristicasMandato[]>([]);
  const getCaracteristicasMandato = async () => {
    const { data } = await obterCaracteristicasConselheiro();
    setCaracteristicasMandato(data);
  }

  return (
    <>
      {/* <Prompt
        message="Tem certeza de que deseja sair da página? Podem existir dados não salvos."
      /> */}

      <Spin spinning={loading} tip={tipLoading}>
        <PageHeader
          className="site-page-header"
          title="Cadastrar Mandato de Conselheiro"
          style={{
            marginTop: "-18px",
            background: "#2160BD",
            padding: 5,
            paddingLeft: 24,
          }}
        />

        <Card variant="borderless" style={{ width: "100%" }}>

          <Form
            layout='vertical'
            form={form}
            style={{ padding: 24 }}
            onFinish={validarConselheiro}
            scrollToFirstError
          >

            <Card title={"Dados Pessoais"}>

              <Row>
                <Col xs={24} xl={8}>
                  <Form.Item hidden={true} name="nuCpf"></Form.Item>
                  <Form.Item hidden={true} name="nmPessoaFisica"></Form.Item>

                  <Form.Item label="CPF" name="cpfDisabled">
                    <Input defaultValue={maskCpf(state.nuCpf)} disabled={true} />
                  </Form.Item>
                </Col>

                <Col xs={24} xl={12}>
                  <Form.Item label="Nome Completo" name="nmPessoaFisicaDisabled">
                    <Input defaultValue={state.nmPessoaFisica} disabled={true} />
                  </Form.Item>
                </Col>

                <Col xs={24} xl={4} >
                  <Form.Item style={{ alignItems: 'center' }}
                    label="Detalhar Cadastro de Pessoa Física"
                  >
                    <Button
                      // style={{ display: (props.manter === 1 || props.manter === 3) ? "inline" : "none" }} // INSERIR OU ALTERAR
                      // disabled={props.desabilitaBotoes()}
                      shape='round'
                      onClick={() => {
                        setMostrarDetalhesPessoaFisica(!mostrarDetalhesPessoaFisica);
                      }}
                      type='primary'
                      icon={<UserOutlined />}
                    />
                  </Form.Item>

                </Col>

              </Row>

            </Card>

            <Row style={{ display: mostrarDetalhesPessoaFisica ? 'inline' : 'none' }}>
              <>
                <PessoaFisicaDadosPessoaisComplementares
                  form={form}
                  idPessoaFisica={state.idPessoaFisica}
                  mostrarDetalhesPessoaFisica={mostrarDetalhesPessoaFisica}
                />
              </>
            </Row>

            <Card title={"Dados do Mandato"}>
              <>
                <ConselheiroPerfil
                  form={form}
                  entidades={entidades}
                  setValueCategoria={setValueCategoria}
                  setValueCondicao={setValueCondicao}
                  valueCategoria={valueCategoria}
                  valueCondicao={valueCondicao}
                  setValueRepresentacao={setValueRepresentacao}
                  valueRepresentacao={valueRepresentacao}
                  manter={manter}
                  dadosConselheiro={undefined}
                />
              </>
            </Card>

            <Tabs>
              <Tabs.TabPane tab="Caracteristicas" key="item-1">
                <>
                  <DirigenteCaracteristica
                    form={form}
                    mandatoCaracteristica={mandatoCaracteristica}
                    setMandatoCaracteristica={setMandatoCaracteristicas}
                    caracteristicasMandato={caracteristicasMandato}
                    manter={manter}
                  />
                </>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Habilitação" key="item-3">
                <>
                  <DirigenteHabilitacao
                    form={form}
                    mandatoHabilitacao={habilitacoes}
                    setMandatoHabilitacao={setHabilitacoes}
                    manter={manter}
                    tipoMandato={2}
                  />
                </>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Documentação" key="item-4">
                <>
                  <DirigenteDocumento
                    form={form}
                    dirigenteDocumento={mandatoDocumentos}
                    setDirigenteDocumento={setMandatoDocumentos}
                    ctrlDoc={ctrlDocCons}
                    manter={manter}
                  />
                </>
              </Tabs.TabPane>

            </Tabs>

            <CadInfoBotoes
              resetForm={resetForm}
              detalhar={false}
              form={form}
              // desabilitaBtnEditar={true}
              // desabilitaBotoes={desabilitaBotoes}
              desabilitar={touched}
              setDesabilitar={setTouched}
              resetColor={resetColor}
              manter={manter}
              setManter={setManter}
            />

          </Form>
        </Card>
      </Spin>

    </>
  );
};

export default Cadastrar;